import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";
import Home from '../views/Home.vue';
import HomeIndex from '../views/home/index.vue';
import Service from "../views/services/services.vue";
import Cooperation from '../views/cooperation/cooperation.vue'
import Contact from '../views/Contact/Contact.vue'
import About from '../views/About/About.vue'
import Privacy from '../views/Privacy/Privacy.vue'
const routes: Array<RouteRecordRaw> = [
    {
        path: '/',
        name: 'home',
        redirect: '/homeMain',
        component: Home,
        children: [
            {
                path: '/homeMain',
                name: 'homeMain',
                component: HomeIndex,
            },
            {
                path: '/service',
                name: 'service',
                component: Service,
            },
            {
                path: '/cooperation',
                name: 'cooperation',
                component: Cooperation,
            },
            {
                path: '/contact',
                name: 'contact',
                component: Contact
            },
            {
                path: '/about',
                name: 'About',
                component: About

            },
            {
                path: '/privacy',
                name: 'Privacy',
                component: Privacy
            }
        ]
    },

];

const router = createRouter({
    history: createWebHashHistory(),
    routes,
});

export default router;
